import { useEffect } from 'react';

// Context
import { useCompareContext } from '@/context/compare';

// Api
import apiProductCompare from '@/api/get/productCompare';

export default () => {
  const [{ productsCode }, { setCompareDate }] = useCompareContext();

  useEffect(() => {
    const successCB = data => setCompareDate(data);
    const code = productsCode.join(',');

    if (code) {
      apiProductCompare({
        successCB,
        code,
      });
    }
  }, [productsCode]);
};
